import { Extra, ModalityIncludedExtra } from '../models/types';
import { calculateExtraTotal, formatExtraPriceDisplay } from './extraPricing';
import { formatSandwichMeriendaLabel } from './extraDisplayName';

export const MERIENDA_EXTRA_ID = 14;
export const MERIENDA_PERRITO_EXTRA_ID = 15;

export type MeriendaType = 'sandwich' | 'perrito';

export function isMeriendaExtra(
    extra: Pick<Extra | ModalityIncludedExtra, 'extra_id' | 'extra_name'>
): boolean {
    if (Number(extra.extra_id) === MERIENDA_EXTRA_ID) {
        return true;
    }
    return /^merienda$/i.test(extra.extra_name.trim());
}

export function isMeriendaPerritoExtra(
    extra: Pick<Extra | ModalityIncludedExtra, 'extra_id' | 'extra_name'>
): boolean {
    if (Number(extra.extra_id) === MERIENDA_PERRITO_EXTRA_ID) {
        return true;
    }
    return /merienda.*perrito/i.test(extra.extra_name);
}

export function findMeriendaPerritoUpgrade(extras: Extra[]): Extra | undefined {
    return extras.find(isMeriendaPerritoExtra);
}

export function getSelectedMeriendaType(selectedExtras: Extra[]): MeriendaType {
    return selectedExtras.some(isMeriendaPerritoExtra) ? 'perrito' : 'sandwich';
}

export function hasMeriendaTypeChoice(
    includedExtras: ModalityIncludedExtra[],
    availableExtras: Extra[]
): boolean {
    return includedExtras.some(isMeriendaExtra) && Boolean(findMeriendaPerritoUpgrade(availableExtras));
}

export function formatMeriendaTypeLabel(type: MeriendaType): string {
    return type === 'perrito' ? 'Perrito' : formatSandwichMeriendaLabel();
}

export function formatMeriendaIncludedDisplay(
    extra: ModalityIncludedExtra,
    selectedExtras: Extra[]
): string {
    const typeLabel = formatMeriendaTypeLabel(getSelectedMeriendaType(selectedExtras));
    const units = Number(extra.included_units);

    if (units > 1) {
        return `Merienda · ${typeLabel} (hasta ${units} unidades)`;
    }

    return `Merienda · ${typeLabel}`;
}

export function formatMeriendaUpgradePriceLabel(
    perritoExtra: Extra,
    currencyFormatter: Intl.NumberFormat
): string {
    if (perritoExtra.info_type === 'ask_shop') {
        return 'Consultar con centro';
    }

    const total = calculateExtraTotal(perritoExtra);
    if (total === 0) {
        return '';
    }

    return `+${formatExtraPriceDisplay(perritoExtra, currencyFormatter)}`;
}

export function filterOutMeriendaPerritoExtra(extras: Extra[]): Extra[] {
    return extras.filter((extra) => !isMeriendaPerritoExtra(extra));
}
